import React, { useState } from 'react';
import './TextArea.css';

const Textarea = ({
  placeholder,
  value,
  onChange,
  error,
  required = false,
  size,
  disabled = false,
  rows = 2,
}) => {
  const [focused, setFocused] = useState(false);

  return (
    <div className="textarea-container">
      <div className="textarea-wrapper">
        <textarea
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className={`style-textarea ${error ? 'textarea-error' : ''} ${size ? size : ''} ${
            focused ? 'expanded' : ''
          }`}
          required={required}
          disabled={disabled}
          rows={focused ? 6 : rows}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
        />
      </div>
      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

export default Textarea;
